import { useEffect, useState } from 'react';
import { loadGoogleMaps } from '../../services/helpers/GoogleMapsLoader';

/**
 * Whether the Maps JS API is usable yet. `@react-google-maps/api` components read the global
 * `google` on mount, so they must not render before `isLoaded` (DASHBOARD-WEB-Q).
 */
export default function useGoogleMaps() {
  const [isLoaded, setIsLoaded] = useState(() => Boolean(window.google?.maps));
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    if (isLoaded) {
      return undefined;
    }

    let mounted = true;

    loadGoogleMaps()
      .then(() => mounted && setIsLoaded(true))
      .catch((error) => mounted && setLoadError(error));

    return () => {
      mounted = false;
    };
  }, [isLoaded]);

  return { isLoaded, loadError };
}
